import API from "@/services/api";

const BASE_URL = 'verve-contacts';

export const verveContactActivityService = {
  /**
   * Fetches the activity history for a specific Verve contact.
   */
  getActivityHistory: async (contactId) => {
    const response = await API.get(`${BASE_URL}/${contactId}/activities`);
    return response.data || response;
  },

  /**
   * Adds a new activity log entry for a specific Verve contact.
   */
  addActivity: async (contactId, activityData) => {
    const payload = typeof activityData === 'string'
      ? { note: activityData }
      : { ...activityData, note: activityData?.note || activityData?.comment || activityData?.text || '' };
    const response = await API.post(`${BASE_URL}/${contactId}/activities`, payload);
    return response.data || response;
  }
};
